import React, { Component } from "react";

import {
  Header,
  Icon,
  Menu,
  Label,
  Button,
  Grid,
  Radio,
  Image,
  Form,
  Input,
  Modal,
  Popup,
  Dropdown,
} from "semantic-ui-react";

import "./location.css";
import Papa from "papaparse";
import * as XLSX from "xlsx";

import home from "../assets/home.png";

import search from "../assets/search.png";
import { Accordion, Card } from "react-bootstrap";

import toastr from "toastr";

import { connect } from "react-redux";
import { locus, auth } from "../actions";
import { Checkbox, Typography, Table, Select, Steps, Spin, Tabs } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";

import { company } from "../actions";
import SelectVariables from "./SelectVariables";

import LocationMap from "./location_map";
import "toastr/build/toastr.min.css";

import { changeTitle } from "../redux/actions";

import { Row, Col, Breadcrumb, Container } from "react-bootstrap";

import video1 from "../assets/video.gif";

const currentDate = new Date().toISOString().slice(0, 10);

// Concatenate current date with the filename
const filename = `intensel-tempalate-input-csv-file-_${currentDate}.csv`;

const buttonRef = React.createRef();

const companyRef = React.createRef();

let mapcards = [];
let companycards = [];
let selectList = "";
let optionList = [];
let newmapcards = [];
let csvcards = [];
let buildingcsvcards = [];
let companyLocationCards = [];
let selectedList = [];

const csvColumns = [
  { title: "Asset Name", dataIndex: "name", key: "name" },
  { title: "Latitude", dataIndex: "latitude", key: "latitude" },
  { title: "Longitude", dataIndex: "longitude", key: "longitude" },
  {
    title: "Revenue (in mil US$/year)",
    dataIndex: "Revenue (in mil US$/year)",
    key: "revenue",
  },
  {
    title: "Replacement Value (US$/sqm)",
    dataIndex: "Replacement Value (US$/sqm )",
    key: "replacementValue",
  },
  { title: "Property Type", dataIndex: "Property Type", key: "propertyType" },
  { title: "Area (in sqm)", dataIndex: "Area (in sqm)", key: "area" },
  {
    title: "Valuation (in US$/sqm)",
    dataIndex: "Valuation (in US$/sqm)",
    key: "valuation",
  },
  { title: "Number of Floors", dataIndex: "Number of Floors", key: "floors" },
  {
    title: "Ownership (0 to 100)",
    dataIndex: "Ownership (0 to 100)",
    key: "ownership",
  },
  {
    title: "Content Value (in US$/sqm)",
    dataIndex: "Content Value (in US$/sqm)",
    key: "contentValue",
  },
  {
    title: "Basement (yes,no)",
    dataIndex: "Basement (yes,no)",
    key: "basement",
  },
  {
    title: "Price per Kwh(in US$)",
    dataIndex: "Price per Kwh(in US$)",
    key: "pricePerKwh",
  },
  {
    title: "Flood Mitigation (low-1,med-2,high-3,no-0)",
    dataIndex: "Flood Mitigation (low-1,med-2,high-3,no-0)",
    key: "floodMitigation",
  },
];

const othersOptions = [
  { key: "Flood", value: "River Flood", text: "Flood" },
  { key: "Rainfall", value: "Rainfall", text: "Rainfall" },

  { key: "Drought Index", value: "Drought Index", text: "Drought Index" },
  //{ key: "Landslide", value: "Landslide", text: "Landslide" },
  { key: "Storm Surge", value: "Storm Surge", text: "Storm Surge" },

  { key: "Extreme heat", value: "Extreme heat", text: "Extreme heat" },
  { key: "Typhoon", value: "Typhoon", text: "Typhoon" },
];

let minedata = [];

const csvData = [
  [
    "name",
    "latitude",
    "longitude",
    "Valuation (in US$/sqm)",
    "Total Valuation (in US$)",
    "Replacement Value (US$/sqm )",
    "Revenue (in mil US$/year)",
    "Content Value (in US$/sqm)",
    "Total Content Value (in US$)",
    "Ownership (0 to 100)",
    "Property Type",
    "Area (in sqm)",
    "Gross Area (in sqm)",

    "Number of Floors",

    "Basement (yes,no)",

    "Flood Mitigation (low-1,med-2,high-3,no-0)",
    "Exclude Ground Floor (yes,no)",
  ],
  [
    "intensel",
    "0.00",
    "0.00",

    "0",
    "",
    "0",
    "0",
    "0",
    "",
    "0",
    "commercial",
    "0",
    "",
    "0",

    "yes",
    "no",
    "0",

    "no",
  ],
];
let company_card = [];
const { TabPane } = Tabs;

const ContinentOptions = [
  { key: "Asia", value: ["Asia", 100.6197, 34.04, 3], text: "Asia" },
  { key: "Europe", value: ["Europe", 15.2551, 54.526, 3], text: "Europe" },
  {
    key: "Australia",
    value: ["Australia", 133.7751, -25.2744, 3],
    text: "Australia",
  },
  { key: "America", value: ["America", -95.7129, 37.0902, 2], text: "America" },
  { key: "Africa", value: ["Africa", 34.5085, 8.7832, 3], text: "Africa" },
];
const unitOptions = [
  { key: "meter", value: "meter", text: "meter" },
  { key: "inch", value: "inch", text: "inch" },
];

const indexOptions = [
  { key: "HSI", value: "HSI", text: "HSI" },
  { key: "S&P-500", value: "S&P-500", text: "S&P-500" },
  { key: "dax", value: "dax", text: "dax" },
  { key: "dowjones", value: "dowjones", text: "dowjones" },
  { key: "nasdaq", value: "nasdaq", text: "nasdaq" },
  { key: "eurostock", value: "eurostock", text: "eurostock" },
  { key: "nifty", value: "nifty", text: "nifty" },
  { key: "nikkie", value: "nikkie", text: "nikkie" },
];
let searchList = [];

const SearchOptions = [
  { key: "HTML Search", value: "html", text: "HTML Search" },
  { key: "Shallow Search", value: "shallow", text: "Shallow Search" },
  { key: "Deep Search", value: "deep", text: "Deep Search" },
];
const columns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Latitude",
    dataIndex: "latitude",
    key: "latitude",
    render: (lat) => lat.toFixed(3),
  },
  {
    title: "Longitude",
    dataIndex: "longitude",
    key: "longitude",
    render: (lon) => lon.toFixed(3),
  },
];

class Location extends Component {
  constructor(props) {
    super(props);
    this.mapRef = React.createRef();
  }

  state = {
    step: 1,
    isEditingTable: false,
    editedCsvData: null,
    csvStep: 1,
    upload: "",
    index: "",
    file: false,
    locations: [],
    query: "",
    farmVariables: [],
    energyVariables: [],
    option: "",
    variables: [],
    buildingVariables: [],
    overwrite: "false",
    company: [],
    portfolio: "",
    selectedOption: null,
    newlocations: [],
    modalOpen: false,
    videoOpen: false,
    loading: false,
    long: 34.0,
    lat: 39.0,
    geocodingComplete: false,
    token: "",
    zoom: 1,
    continent: "Continents",
    selectedTags: [],
    allTags: [],
    buildingselectedTags: [],
    allbuildingTags: [],
    optional: "",
    infoOpen: false,
    buildinginfoOpen: false,
    restrictOpen: false,
    address: "",
    companyloading: false,
    search_loading: false,
    buildingmodalOpen: false,
    search_type: "",
    index: "HSI",
    modalIndicesOpen: false,
    portfolio_value: "",
    portfolio_name: "",
    modalCompanyOpen: false,
    modalFileOpen: false,
    csv: "",
    currency: null,
    unit: null,
    modalCSVOpen: false,
    csv_currency: null,
    csv_unit: null,
    apiErrors: "",
  };
  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;
    this.setState({ activeIndex: newIndex });
  };
  handleIndex = (e) => {
    console.log("checked", e.target.id);

    if (this.state.index == e.target.id) {
      this.setState({ index: "" });
    } else {
      this.setState({ index: e.target.id }, () =>
        this.props.getIndices(this.state.index),
      );
    }
  };

  handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    console.log("File selected:", file.name);
    this.setState({ csv: file });

    const fileExt = file.name
      .split(".")
      .pop()
      .toLowerCase();

    if (fileExt === "csv") {
      // ✅ Parse CSV
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: (result) => {
          const headers = result.meta.fields || [];
          const csvColumns = headers.map((col) => ({
            title: col,
            dataIndex: col,
            key: col,
          }));
          this.setState({
            csvData: result.data,
            csvColumns,
          });
        },
        error: (err) => console.error("CSV Parse Error:", err),
      });
    } else if (fileExt === "xlsx" || fileExt === "xls") {
      // ✅ Parse Excel
      const reader = new FileReader();
      reader.onload = (evt) => {
        const data = new Uint8Array(evt.target.result);
        const workbook = XLSX.read(data, { type: "array" });

        // First sheet
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        // Convert sheet to JSON
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

        // Get headers from first row
        const headers = Object.keys(jsonData[0] || {});
        const csvColumns = headers.map((col) => ({
          title: col,
          dataIndex: col,
          key: col,
        }));

        this.setState({
          csvData: jsonData,
          csvColumns,
        });
      };
      reader.readAsArrayBuffer(file);
    } else {
      console.error("Unsupported file type:", fileExt);
    }
  };
  handleDeleteMarker = (id) => {
    // Your delete marker logic in the parent component
    console.log(`Deleting marker with ID: ${id}`);
  };
  handleChange = (e, { value }) => {
    this.setState({ selectedOption: value }, () =>
      console.log("selectedoption", this.state.selectedOption),
    );
  };
  handleCSVSubmit = (e) => {
    e.preventDefault();

    const { csv_currency, csv_unit, token } = this.state;

    // Generate the current timestamp
    const now = new Date();
    const dateTimeString = now.toISOString().replace(/[:.-]/g, ""); // Format as YYYYMMDDTHHMMSS

    // Construct the filename dynamically
    const filename = `${dateTimeString}_csv_template.xlsx`;

    // Construct the URL with query parameters
    const url = `https://api.intensel.net/api/v2/download_upload_csv_template/?unit=meter&currency=USD`;

    this.setState({ loading: true }, () => {
      // Perform the GET request with Authorization header
      fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Token ${token}`, // Add the token here
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to fetch the CSV template.");
          }
          return response.blob(); // Fetch the file as a Blob
        })
        .then((blob) => {
          // Create a URL for the file and trigger the download
          const downloadUrl = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.download = filename; // Use the dynamically generated filename
          link.click();

          // Clean up the object URL
          window.URL.revokeObjectURL(downloadUrl);

          // Close the modal by setting modalCSVOpen to false
          this.setState({ modalCSVOpen: false });

          // Reset loading state
          this.setState({ loading: false });
        })
        .catch((error) => {
          console.error("Error:", error);
          this.setState({ loading: false });
        });
    });
  };

  onSubmit = (e) => {
    e.preventDefault();
    if (this.state.loading) return;
    let defaultvar = ["River Flood", "Typhoon", "Storm Surge"];
    let variables = defaultvar.concat(this.state.variables);
    console.log("variables", variables, this.state.variables);
    let formdata = new FormData();

    formdata.append("data", JSON.stringify(this.state.locations));
    //formdata.append("unit", this.state.unit);
    formdata.append("portfolio_name", this.state.portfolio);
    formdata.append("portfolio_variables", JSON.stringify(variables));
    formdata.append(
      "non_building_variables",
      JSON.stringify(this.state.buildingVariables),
    );
    formdata.append("base_unit", "meter");
    formdata.append("base_currency", "USD");

    console.log("final data", formdata.get("location"));
    this.setState({ loading: true }, () => {
      this.props
        .addLocations(formdata)
        .then((res) => {
          if (res?.error?.length) {
            // Display errors in modal without redirecting
            this.setState({ loading: false });
          }
        })
        .catch((err) => {
          this.setState({ loading: false });
        });
    });
  };
  onCompanySubmit = (e) => {
    e.preventDefault();
    let defaultvar = [
      "River Flood",
      "Typhoon",
      "Storm Surge",
      "Wild Fire",
      "Landslide",
      "Rainfall Flood",
      "Extreme Heat",
      "Snow Fall",
      "Sea Level Rise",
      "Drought",
    ];
    let variables = defaultvar.concat(this.state.variables);
    console.log("variables", variables, this.state.variables);
    let formdata = new FormData();

    formdata.append("data", JSON.stringify(this.state.locations));
    formdata.append("is_benchmark", true);
    formdata.append("ticker", this.state.company);
    formdata.append("index_name", this.state.index);
    formdata.append("portfolio_name", this.state.portfolio);
    formdata.append("portfolio_variables", JSON.stringify(variables));
    formdata.append(
      "non_building_variables",
      JSON.stringify(this.state.buildingVariables),
    );
    console.log("final data", formdata.get("location"));
    this.setState({ loading: true }, () => {
      this.props.addCompanyLocations(formdata);
    });
  };
  onFileSubmit = (e) => {
    e.preventDefault();

    let defaultvar = ["River Flood", "Typhoon", "Storm Surge"];
    let variables = defaultvar.concat(this.state.variables);
    let formdata = new FormData();

    formdata.append("upload_file", this.state.csv);
    formdata.append("portfolio_name", this.state.portfolio);
    formdata.append("unit", this.state.unit);
    formdata.append("portfolio_variables", JSON.stringify(variables));
    formdata.append(
      "non_building_variables",
      JSON.stringify(this.state.buildingVariables),
    );
    formdata.append("base_unit", "meter");
    formdata.append("base_currency", "USD");

    this.setState({ loading: true, apiErrors: [] }, () => {
      this.props
        .addLocations(formdata)
        .then((res) => {
          if (res?.error?.length) {
            this.setState({
              loading: false,
              apiErrors: res.error, // 👈 store errors
            });
          } else {
            this.setState({ loading: false, apiErrors: [] });
          }
        })
        .catch((err) => {
          this.setState({
            loading: false,
            apiErrors: ["Something went wrong. Please try again."],
          });
        });
    });
  };

  onIndicesSubmit = (e) => {
    e.preventDefault();

    let formdata = new FormData();

    formdata.append("index_name", this.state.index);
    formdata.append("portfolio_name", this.state.portfolio);

    this.setState({ loading: true }, () => {
      this.props.addIndex(formdata);
    });
  };
  onbuildingSubmit = (e) => {
    e.preventDefault();
    let formdata = new FormData();
    formdata.append("value", JSON.stringify(this.state.locations));
    formdata.append("portfolio_name", this.state.portfolio);
    formdata.append("variables", JSON.stringify(this.state.variables));
    this.setState({ loading: true }, () => {
      this.props.addBuildingLocations(formdata);
    });
  };

  handleOpenDialog = (e) => {
    if (buttonRef.current) {
      buttonRef.current.open(e);
    }
  };

  handleFileLoad = (data) => {
    csvcards = [];
    for (let i = 1; i < data.length - 1; i++) {
      if (data[i].data[3] == "") {
        data[i].data[3] = "NA";
      }
      if (data[i].data[5] == "") {
        data[i].data[5] = "NA";
      }
      if (
        data[i].data[4] == "" ||
        !this.state.optional.includes("Construction Cost")
      ) {
        data[i].data[4] = "NA";
      }
      if (data[i].data[6] == "" || !this.state.optional.includes("Area")) {
        data[i].data[6] = "NA";
      }
      if (data[i].data[7] == "" || !this.state.optional.includes("Valuation")) {
        data[i].data[7] = "NA";
      }
      if (data[i].data[8] == "" || !this.state.optional.includes("Floors")) {
        data[i].data[8] = "NA";
      }
      if (data[i].data[10] == "" || !this.state.optional.includes("Solar")) {
        data[i].data[10] = "NA";
      }
      if (data[i].data[11] == "" || !this.state.optional.includes("Wind")) {
        data[i].data[11] = "NA";
      }
      if (data[i].data[12] == "" || !this.state.optional.includes("Hydro")) {
        data[i].data[12] = "NA";
      }
      if (data[i].data[13] == "" || !this.state.optional.includes("Wheat")) {
        data[i].data[13] = "NA";
      }
      if (data[i].data[14] == "" || !this.state.optional.includes("Rice")) {
        data[i].data[14] = "NA";
      }
      if (data[i].data[15] == "" || !this.state.optional.includes("Maize")) {
        data[i].data[15] = "NA";
      }
      if (data[i].data[16] == "" || !this.state.optional.includes("Fruit")) {
        data[i].data[16] = "NA";
      }
      if (data[i].data[17] == "" || !this.state.optional.includes("Veg")) {
        data[i].data[17] = "NA";
      }
      if (data[i].data[9] == "" || !this.state.optional.includes("Ownership")) {
        data[i].data[9] = "NA";
      }

      csvcards.push({
        name: data[i].data[0],
        latitude: data[i].data[1],
        longitude: data[i].data[2],
        revenue: data[i].data[3],
        property_type: data[i].data[5],
        country_code: "NA",
        construction_cost: data[i].data[4],
        area: data[i].data[6],
        valuation: data[i].data[7],
        stories: data[i].data[8],
        solar_production: data[i].data[10],
        hydro_production: data[i].data[12],
        wind_production: data[i].data[11],
        wheat_production: data[i].data[13],
        rice_production: data[i].data[14],
        maize_production: data[i].data[15],
        fruit_production: data[i].data[16],
        vegetable_production: data[i].data[17],
        ownership: data[i].data[9],
      });
    }
    this.setState({ allTags: csvcards, infoOpen: false }, () =>
      console.log("multiple", this.state.allTags),
    );
  };

  handleCompanyDialog = (e) => {
    if (companyRef.current) {
      companyRef.current.open(e);
    }
  };
  handleEnableEdit = () => {
    this.setState({
      isEditingTable: true,
      editedCsvData: JSON.parse(JSON.stringify(this.state.csvData)), // deep copy
    });
  };

  // Method to save changes
  handleSaveChanges = () => {
    this.setState({
      csvData: this.state.editedCsvData,
      isEditingTable: false,
    });
    toastr.success("Changes saved successfully!");
  };

  // Method to cancel editing
  handleCancelEdit = () => {
    this.setState({
      isEditingTable: false,
      editedCsvData: null,
    });
  };

  // Handle cell edits
  handleCellEdit = (rowIndex, columnKey, value) => {
    const updatedData = [...this.state.editedCsvData];
    updatedData[rowIndex][columnKey] = value;
    this.setState({ editedCsvData: updatedData });
  };

  // Generate columns (editable or read-only based on state)
  generateColumns = () => {
    const { isEditingTable } = this.state;

    return this.state.csvColumns.map((col) => ({
      ...col,
      width: 150, // Fixed width for each column
      ellipsis: false, // Disable ellipsis to show full content
      render: (text, record, index) => {
        if (isEditingTable) {
          return (
            <input
              style={{
                width: "100%",
                minWidth: "120px",
                border: "1px solid #d9d9d9",
                borderRadius: "2px",
                padding: "4px 11px",
                backgroundColor: "transparent",
                color: "inherit",
              }}
              value={this.state.editedCsvData[index][col.dataIndex] || ""}
              onChange={(e) =>
                this.handleCellEdit(index, col.dataIndex, e.target.value)
              }
            />
          );
        }
        return <span style={{ whiteSpace: "nowrap" }}>{text || "-"}</span>;
      },
    }));
  };

  handelOnError = (err, file, inputElem, reason) => {
    console.log(err);
  };

  handleOpen = () => {
    this.setState({
      modalOpen: true,
      loading: false,
    });
    this.props.clearErrors(); // define this action
  };
  handleCompanyOpen = () => this.setState({ modalCompanyOpen: true });
  handleFileOpen = () => {
    this.setState({
      modalFileOpen: true,
      loading: false,
    });
    this.props.clearErrors(); // define this action
  };
  handleIndicesOpen = () => this.setState({ modalIndicesOpen: true });
  handlebuildOpen = () => this.setState({ buildingmodalOpen: true });
  handlevideoOpen = () => this.setState({ videoOpen: true });
  handleinfoOpen = () => this.setState({ infoOpen: true });
  handleBuildinginfoOpen = () => this.setState({ buildinginfoOpen: true });
  handleClose = () =>
    this.setState({
      modalOpen: false,
      videoOpen: false,
      infoOpen: false,
      restrictOpen: false,
      buildinginfoOpen: false,
      buildingmodalOpen: false,
      modalIndicesOpen: false,
      modalFileOpen: false,
      modalCompanyOpen: false,
      modalCSVOpen: false,
      csv_unit: null,
      csv_currency: null,
      unit: null,
      currency: null,
      portfolio: null,
    });

  showModal = () => {
    this.setState({ modalCSVOpen: true });
  };
  handleCSVCurrencyChange = (value) => {
    this.setState({ csv_currency: value });
  };

  // Handle Unit Change
  handleCSVUnitChange = (value) => {
    this.setState({ csv_unit: value });
  };
  handleCurrencyChange = (value) => {
    this.setState({ currency: value });
  };

  // Handle Unit Change
  handleUnitChange = (value) => {
    this.setState({ unit: value });
  };
  handleContinent = (e, { value }) => {
    console.log("Continents", value);
    this.setState({
      continent: value[0],
      long: value[1],
      lat: value[2],
      zoom: value[3],
    });
  };

  componentDidMount() {
    let token = localStorage.getItem("token");
    this.setState({ token: token });
    // console.log("login response", this.props.auth.log_data);

    if (
      this.props.auth.log_data &&
      this.props.auth.log_data.pending_notifications &&
      this.props.auth.log_data.pending_notifications.length > 0
    ) {
      this.props.auth.log_data.pending_notifications.forEach((notification) => {
        const { id, title, message, notification_type } = notification;
        const toastMessage = `${title}: ${message}`;

        let toastType = "info"; // default type
        if (notification_type === "success") toastType = "success";
        else if (notification_type === "warning") toastType = "warning";
        else if (notification_type === "error") toastType = "error";

        toastr.options = {
          positionClass: "toast-top-right",
          tapToDismiss: false,
          progressBar: true,
          closeButton: true,
          disableTimeOut: true,
          timeOut: 0,
          onclick: () => {
            window.location.href = "/changelog"; // Redirect to /changelog on click
          },
          onCloseClick: () => {
            let formdata = new FormData();
            formdata.append("notification_id", id);
            if (this.props.Notification) {
              this.props.Notification(formdata);
            }
          },
        };

        toastr[toastType](toastMessage);
      });
    }
  }

  componentWillUnmount() {
    if (this.view) {
      this.view.destroy();
    }
    mapcards = [];
  }

  handleRemoveFile = (e) => {
    // Note that the ref is set async, so it might be null at some point
    if (buttonRef.current) {
      buttonRef.current.removeFile(e);
    }
  };

  handleRemoveLocation = (index) => {
    var array = [...this.state.locations];
    console.log("index", index);
    if (index !== -1) {
      array.splice(index, 1);
      this.setState({ locations: array });
      mapcards.splice(index, 1);
    }
  };

  handleRemoveNewLocation = (index) => {
    var array = [...this.state.newlocations];
    if (index !== -1) {
      array.splice(index, 1);
      this.setState({ newlocations: array });
      newmapcards.splice(index, 1);
    }
  };
  handleSearch = (e, { value }) => {
    console.log("company selectio", value);
    for (let i = 0; i < value.length; i++) {
      this.setState({ company: value[i] }, () => {
        this.props.getCompanyLocations(this.state.company);
        console.log("companies", value);
        setTimeout(() => {
          this.handleAsync();
        }, 1000);
      });
    }
  };
  handleSearchType = (e, { value }) => {
    this.setState({ search_type: value });
  };
  handleAsync() {
    console.log("calling", this.props.company_location.hits);
    if (this.props.company_location.hits) {
      for (let i = 0; i < this.props.company_location.hits.length; i++) {
        company_card.push({
          name: this.props.company_location.hits[i].document.address_data,
          latitude: this.props.company_location.hits[i].document.latitude,
          longitude: this.props.company_location.hits[i].document.longitude,
        });
      }
      this.setState({ locations: company_card });
    }

    console.log("result of search", this.props.company_location.grouped_hits);
  }

  handleAddress = (e) => {
    let formdata = new FormData();
    formdata.append("company_name", this.state.address);

    this.setState({ companyloading: true }, () => this.props.getName(formdata));
  };

  handleOptions = (e) => {
    if (e.target.value.length > 0) {
      this.setState({ search_loading: true, query: e.target.value }, () =>
        this.props.getCompanyName(this.state.query),
      );

      console.log("search ", this.props.company_name);
      if (this.props.company_name.grouped_hits) {
        console.log("name", this.props.company_name.grouped_hits);

        for (let i = 0; i < this.props.company_name.grouped_hits.length; i++) {
          searchList.push({
            key: this.props.company_name.grouped_hits[i].hits[0].document
              .ticker,
            text:
              this.props.company_name.grouped_hits[i].hits[0].document
                .company_name +
              "(" +
              this.props.company_name.grouped_hits[i].hits[0].document.ticker +
              ")",
            value: this.props.company_name.grouped_hits[i].hits[0].document
              .ticker,
          });
        }

        this.setState(
          {
            option: searchList,
            search_loading: false,
            index: this.props.company_name.grouped_hits[0].hits[0].document
              .index,
          },
          () => console.log("option", this.state.option),
        );
      }
    }

    /* this.setState({ query: e.target.value }, () =>
        console.log("query", this.state.query)
      );*/
  };
  /*handleOptions =(e)=>{
  	
    if(e.target.value.length>1){
      this.selectList=companyList.filter(company=>company.NAME.slice(0,2).toLowerCase()==e.target.value.slice(0,2).toLowerCase())
    	
      let searchList = this.selectList.map(({NAME}) =>{
  return{
    key:NAME,
    value:NAME,
    text:NAME
  }
})      
    	
      this.setState({option:searchList},()=>console.log("option",this.state.option));
    	
    }
  	
          this.setState({query:e.target.value},()=>console.log(this.state.query))

  }*/

  handleLogout = () => {
    this.props.logout();
  };
  onChange = (checkedValues) => {
    console.log("checked", checkedValues);
    this.setState({ variables: checkedValues });
  };
  onFarmChange = (checkedValues) => {
    this.setState({ farmVariables: checkedValues });
  };
  onEnergyChange = (checkedValues) => {
    this.setState({ energyVariables: checkedValues });
  };
  onBuildingChange = (checkedValues) => {
    let energyBuildings = [
      "solar production",
      "wind production",
      "hydro production",
    ];
    let farmCrops = [
      "wheat production",
      "vegetable production",
      "maize production",
      "fruit production",
      "rice production",
    ];

    let energyBuildingValues = checkedValues.filter((value) =>
      energyBuildings.includes(value),
    );
    let farmCropsValues = checkedValues.filter((value) =>
      farmCrops.includes(value),
    );

    this.setState(
      {
        buildingVariables: {
          energy: energyBuildingValues,
          agriculture: farmCropsValues,
        },
      },
      () => console.log("building", this.state.buildingVariables),
    );
  };

  handleOptional = (checkedValues) => {
    this.setState({ optional: checkedValues }, () =>
      console.log("optional", this.state.optional),
    );
  };
  handleCompanyLoad = (data) => {
    console.log("filename", data[1].data[0]);
    for (let i = 1; i < 3; i++) {
      this.props.getCoordinates(data[i].data[0]);

      if (this.props.point.type) {
        minedata.push(this.props.point.features[i].geometry.coordinates);
        console.log("mine data", minedata);
      }
    }
  };
  handleMapDataChange = (newMapData) => {
    console.log("map", newMapData);
    this.setState({ locations: newMapData });
  };
  handleAsset = (address, latitude, longitude) => {
    mapcards.push({
      name: address,
      latitude: latitude,
      longitude: longitude,
    });
    this.setState({ locations: mapcards }, () =>
      console.log("location map", this.state.locations, mapcards.length),
    );
  };
  handleClear = () => {
    companycards = [];
    this.setState({ locations: [], address: "" });
  };

  addtoSelected(asset) {
    selectedList.push(asset);
    var array = [...this.state.allTags];
    var index = array.indexOf(asset);
    if (index !== -1) {
      array.splice(index, 1);
      this.setState({ allTags: array });
    }
    this.setState({ selectedTags: selectedList, locations: selectedList });
  }
  remove(asset) {
    var array = [...this.state.selectedTags];
    var index = array.indexOf(asset);
    if (index !== -1) {
      array.splice(index, 1);
      this.setState({ selectedTags: array, locations: array }, () =>
        console.log("remove", this.state.selectedTags),
      );
    }
    this.state.allTags.push(asset);
  }
  addAll = () => {
    var array = [...this.state.allTags];
    this.setState({ selectedTags: array, locations: array });
  };
  clearAll = () => {
    this.setState({ selectedTags: "", locations: "", allTags: "" });
  };
  handleLocation = () => {
    company_card = [];
    this.setState(
      { locations: "" },
      console.log("tab change", this.state.locations),
    );
  };

  addtobuildingSelected(asset) {
    selectedList.push(asset);
    var array = [...this.state.allbuildingTags];
    var index = array.indexOf(asset);
    if (index !== -1) {
      array.splice(index, 1);
      this.setState({ allbuildingTags: array });
    }
    this.setState({
      buildingselectedTags: selectedList,
      locations: selectedList,
    });
  }
  buildingremove(asset) {
    var array = [...this.state.buildingselectedTags];
    var index = array.indexOf(asset);
    if (index !== -1) {
      array.splice(index, 1);
      this.setState({ buildingselectedTags: array, locations: array }, () =>
        console.log("remove", this.state.buildingselectedTags),
      );
    }
    this.state.allbuildingTags.push(asset);
  }
  addbuildingAll = () => {
    var array = [...this.state.allbuildingTags];
    this.setState({ buildingselectedTags: array, locations: array });
  };
  clearbuildingAll = () => {
    this.setState({
      buildingselectedTags: "",
      locations: "",
      allbuildingTags: "",
    });
  };

  render() {
    const { Text, Link } = Typography;
    const { Step } = Steps;

    const { activeIndex, others } = this.state;

    if (this.props.point.type) {
      minedata.push([
        this.props.point.features[0].place_name,
        this.props.point.features[0].geometry.coordinates[0],
        this.props.point.features[0].geometry.coordinates[1],
      ]);
      console.log("minedata", minedata);
    }
    if (company_card.length > 0) {
      companyLocationCards = [];
      console.log("company card", company_card);
      for (let i = 0; i < company_card.length; i++) {
        companyLocationCards.push(
          <div className="table__row">
            {company_card[i].name ? (
              <div
                className="table__cell"
                style={{ fontWeight: "bold", color: "black" }}
              >
                {i}
                <Icon name="map marker alternate" style={{ color: "blue" }} />
                {company_card[i].name.slice(0, 20)}
              </div>
            ) : null}

            {company_card[i].latitude ? (
              <div className="table__cell">
                {company_card[i].latitude.toFixed(3)}
              </div>
            ) : null}
            {company_card[0].longitude ? (
              <div className="table__cell">
                {company_card[i].longitude.toFixed(3)}
              </div>
            ) : null}
          </div>,
        );
      }
    }

    if (this.props.location.state) {
      let newmapcards = this.props.location.state.assets.assets;

      var newcards = [];

      if (newmapcards.length > 0) {
        this.state.newlocations = newmapcards;

        console.log("this.s", this.state.newlocations);
        for (let i = 0; i < this.state.newlocations.length; i++) {
          newcards.push(
            <Grid.Column width="2" className="cont">
              <Label className="card">
                <div className="front">
                  <div className="img-cont">
                    <Image
                      src={home}
                      alt=""
                      style={{ float: "center" }}
                      verticalAlign="middle"
                    />
                  </div>
                  <div className="content-cont">
                    <p
                      style={{
                        textAlign: "center",
                        color: "#015edc",
                        fontSize: "12px",
                      }}
                    >
                      {this.state.newlocations[i].name}
                    </p>
                  </div>
                </div>
                <div className="back">
                  <button
                    style={{
                      float: "right",
                      backgroundColor: "white",
                      border: "0px",
                      fontSize: "10px",
                      color: "grey",
                      marginLeft: "55%",
                    }}
                    onClick={() => this.handleRemoveNewLocation(i)}
                  >
                    <Image
                      src={search}
                      style={{ float: "right", padding: "8px", opacity: "0.5" }}
                      color="grey"
                      size="mini"
                    />
                  </button>

                  <p
                    style={{
                      textAlign: "center",
                      color: "#015edc",
                      fontSize: "12px",
                    }}
                  >
                    <Icon
                      name="map marker alternate"
                      style={{ color: "#015edc" }}
                      size="large"
                    />
                    <br />
                    Lat {this.state.newlocations[i].latitude}
                    <br />
                    Long {this.state.newlocations[i].longitude}
                  </p>
                </div>
              </Label>
            </Grid.Column>,
          );
        }
      }
    }

    const { value, continent } = this.state;
    var cards = [];
    var csvtags = [];
    var buildingcsvtags = [];
    console.log("location map render", this.state.locations, mapcards);
    if (mapcards.length > 0) {
      console.log("mapcardsssssssss", this.state.locations);
      for (let i = 0; i < this.state.locations.length; i++) {
        cards.push(
          <div className="table__row">
            <div
              className="table__cell"
              style={{ fontWeight: "bold", color: "black" }}
            >
              {i + 1}{" "}
              <Icon name="map marker alternate" style={{ color: "blue" }} />
              {this.state.locations[i].name.slice(0, 20)}
            </div>

            <div className="table__cell">
              {this.state.locations[i].latitude.toFixed(3)}
            </div>
            <div className="table__cell">
              {this.state.locations[i].longitude.toFixed(3)}
            </div>
            <div className="table__cell">
              <Icon
                style={{ paddingLeft: "10%", cursor: "pointer" }}
                name="trash alternate"
                onClick={() => {
                  this.handleDeleteMarker(i);

                  this.handleRemoveLocation(i);
                }}
              ></Icon>
            </div>
          </div>,
        );
      }
    }

    console.log("props", this.props.name);
    if (this.props.name.length > 0 && this.state.address.length > 0) {
      this.state.companyloading = false;
      this.state.locations = [];
      companycards = [];
      for (let i = 0; i < this.props.name.length; i++) {
        this.state.locations.push({
          name: this.props.name[i].address,
          latitude: this.props.name[i].lat,
          longitude: this.props.name[i].lon,
          revenue: "NA",
          property_type: "NA",
          country_code: "NA",
        });
        let src = "//logo.clearbit.com/";
        companycards.push(
          <Grid.Column width="2" className="cont">
            <Label className="card">
              <div className="front">
                <div className="img-cont">
                  <Image
                    src={src + this.props.name[i].domain}
                    alt=""
                    style={{ float: "center" }}
                    verticalAlign="middle"
                  />
                </div>
                <div className="content-cont">
                  <p
                    style={{
                      textAlign: "center",
                      color: "#18202F",
                      fontSize: "12px",
                    }}
                  >
                    {this.props.name[i].address}
                  </p>
                </div>
              </div>
              <div className="back">
                <button
                  style={{
                    float: "right",
                    backgroundColor: "white",
                    border: "0px",
                    fontSize: "10px",
                    color: "grey",
                    marginLeft: "55%",
                  }}
                  onClick={() => this.handleRemoveLocation(i)}
                >
                  <Image
                    src={search}
                    style={{ float: "right", padding: "8px", opacity: "0.5" }}
                    color="grey"
                    size="mini"
                  />
                </button>

                <p
                  style={{
                    textAlign: "center",
                    color: "#18202F",
                    fontSize: "12px",
                  }}
                >
                  <Icon
                    name="map marker alternate"
                    style={{ color: "#18202F  " }}
                    size="large"
                  />
                  <br />
                  Lat {this.props.name[i].lat}
                  <br />
                  Long {this.props.name[i].lon}
                </p>
              </div>
            </Label>
          </Grid.Column>,
        );
      }
      console.log("company location", this.state.locations);
    }

    if (csvcards.length > 0) {
      for (let i = 0; i < this.state.allTags.length; i++) {
        csvtags.push(
          <Label style={{ display: "block" }}>
            {this.state.allTags[i]["name"]}{" "}
            <Icon
              name="plus"
              onClick={() => this.addtoSelected(this.state.allTags[i])}
              style={{ float: "right" }}
            />
          </Label>,
        );
      }
    }
    if (buildingcsvcards.length > 0) {
      for (let i = 0; i < this.state.allbuildingTags.length; i++) {
        buildingcsvtags.push(
          <Label style={{ display: "block" }}>
            {this.state.allbuildingTags[i]["name"]}{" "}
            <Icon
              name="plus"
              onClick={() =>
                this.addtobuildingSelected(this.state.allbuildingTags[i])
              }
              style={{ float: "right" }}
            />
          </Label>,
        );
      }
    }

    return (
      <div>
        <br />

        <Container fluid style={{ padding: "0.7%" }}>
          <Row className="Location_Content">
            <Col>
              <Tabs
                className="location"
                defaultActiveKey="Asset"
                onChange={this.handleLocation}
                destroyInactiveTabPane
              >
                <TabPane tab="Asset Location" key="Asset" className="Map">
                  <br />

                  <Steps
                    current={this.state.step - 1}
                    className="custom-steps"
                    labelPlacement="vertical"
                  >
                    <Step
                      title="Mark or Upload location"
                      description="Mark on the map for specific location"
                      icon={this.state.step > 1 ? <CheckCircleFilled /> : null}
                    />
                    <Step
                      title="Portfolio Name and Hazard"
                      description="Select hazard for analysis"
                    />
                    <Step
                      title="Location Assets"
                      description="Table view with detailed portfolio location assets"
                    />
                  </Steps>
                  <br />

                  {this.state.step === 1 && (
                    <>
                      <LocationMap
                        lat={this.state.lat}
                        long={this.state.long}
                        zoom={this.state.zoom}
                        onMapDataChange={this.handleMapDataChange}
                        onGeocodingComplete={(status) =>
                          this.setState({ geocodingComplete: status })
                        }
                      />
                      <div style={{ marginTop: 20 }}>
                        <Button
                          type="primary"
                          onClick={() => this.setState({ step: 2 })}
                          disabled={
                            this.state.locations.length === 0 ||
                            !this.state.geocodingComplete
                          }
                          style={{ float: "right" }}
                        >
                          Next: Select Variables
                        </Button>
                      </div>
                    </>
                  )}
                  {this.state.step === 2 && (
                    <Form
                      style={{
                        paddingTop: "2%",
                        paddingLeft: "15%",
                        paddingRight: "15%",
                      }}
                    >
                      {this.props.location.state ? (
                        <div>
                          <p style={{ marginLeft: "35%" }}>
                            New Portfolio{" "}
                            <Checkbox
                              label="OverWrite Existing"
                              value={this.state.overwrite}
                              onChange={(e) =>
                                this.setState(
                                  { overwrite: !this.state.overwrite },
                                  () =>
                                    console.log(
                                      "ovewrite",
                                      this.state.overwrite,
                                    ),
                                )
                              }
                              toggle
                            />
                          </p>
                          {this.state.overwrite ? (
                            <Form.Field
                              control={Input}
                              label="Portfolio Name"
                              value={this.state.portfolio}
                              onChange={(e) =>
                                this.setState({ portfolio: e.target.value })
                              }
                            />
                          ) : (
                            <Form.Field
                              control={Input}
                              label="Portfolio"
                              defaultValue={
                                this.props.location.state.assets.name
                              }
                              disabled
                            />
                          )}
                        </div>
                      ) : (
                        <div>
                          <Form.Field
                            id="form-input-control-portfolio"
                            control={Input}
                            value={this.state.portfolio}
                            onChange={(e) =>
                              this.setState({ portfolio: e.target.value })
                            }
                            style={{ border: "0px" }}
                            label="Portfolio Name"
                          />

                          {/* <Dropdown  placeholder="Variables for Analysis" fluid multiple  selection selectOnBlur={false} options={othersOptions} value={others} defaultValue={['Flood','Typhoon','Storm Surge']}onChange={(e,{value})=>this.handleChange(value,'others')}/> */}
                          <SelectVariables
                            onChange={this.onChange}
                            value={this.state.variables}
                          />
                        </div>
                      )}

                      <div style={{ marginTop: 20 }}>
                        <Button
                          onClick={() => this.setState({ step: 1 })}
                          style={{ marginRight: 8 }}
                        >
                          Back
                        </Button>
                        <Button
                          style={{ float: "right" }}
                          type="primary"
                          onClick={() => this.setState({ step: 3 })}
                          disabled={!this.state.portfolio}
                        >
                          Next: Review & Submit
                        </Button>
                      </div>
                    </Form>
                  )}
                  {this.state.step === 3 && (
                    <>
                      <Table
                        className="dark-mode-table"
                        dataSource={this.state.locations}
                        columns={columns}
                      />

                      <Button
                        type="primary"
                        onClick={this.onSubmit}
                        disabled={
                          !this.state.portfolio ||
                          this.state.locations.length === 0 ||
                          this.state.loading
                        }
                      >
                        {this.state.loading ? (
                          <Spin size="small" />
                        ) : (
                          "Create Portfolio"
                        )}
                      </Button>
                    </>
                  )}
                </TabPane>
                <TabPane
                  className="location"
                  tab="Multiple Asset CSV"
                  key="Multiple Asset CSV"
                >
                  <br />
                  <Steps
                    current={this.state.csvStep - 1}
                    className="custom-steps"
                    labelPlacement="vertical"
                  >
                    <Step
                      title="Upload CSV"
                      description="Upload your assets via CSV file"
                      icon={
                        this.state.csvStep > 1 ? <CheckCircleFilled /> : null
                      }
                    />
                    <Step
                      title="Portfolio Name and Hazard"
                      description="Select hazard variables for analysis"
                      icon={
                        this.state.csvStep > 2 ? <CheckCircleFilled /> : null
                      }
                    />
                    <Step
                      title="Review & Submit"
                      description="Review uploaded assets and confirm"
                    />
                  </Steps>
                  <br />

                  {this.state.csvStep === 1 && (
                    <Row className="assetcsv">
                      <Col md={8} sm={12} xs={12}>
                        <h3 className="h3assetcsv">
                          <span className={"dark-mode-primary-color"}>
                            Upload CSV <Icon name="file alternate" />
                          </span>
                        </h3>

                        <Button
                          className="samplecsv"
                          onClick={this.handleCSVSubmit}
                        >
                          <span className={"dark-mode-primary-color"}>
                            Download Sample CSV
                          </span>
                        </Button>

                        <Form>
                          <div>
                            <label
                              style={{ color: "#18202F", fontSize: "16px" }}
                            >
                              File Input
                            </label>
                            <Input
                              className="filecsv"
                              type="file"
                              ref={(input) => (this.filesInput = input)}
                              name="file"
                              onChange={this.handleFileChange}
                            />
                          </div>
                        </Form>

                        <div style={{ marginTop: 20 }}>
                          <Button
                            type="primary"
                            style={{ float: "right" }}
                            disabled={
                              !this.state.csvData ||
                              this.state.csvData.length === 0
                            }
                            onClick={() => this.setState({ csvStep: 2 })}
                          >
                            Next: Portfolio & Variables
                          </Button>
                        </div>
                      </Col>

                      {/* Accordion section stays here */}
                      <Col lg={4}>
                        <div className="notecsv">
                          <h4 className="h3assetcsv">
                            Note (Click on Header to Expand)
                          </h4>
                          <Accordion defaultActiveKey="0">
                            <Card>
                              <Accordion.Toggle
                                as={Card.Header}
                                eventKey="0"
                                style={{ cursor: "pointer" }}
                              >
                                Instructions for submitting multiple assets
                              </Accordion.Toggle>
                              <Accordion.Collapse eventKey="0">
                                <Card.Body>
                                  <ul>
                                    <li>
                                      For submitting multiple assets on the
                                      platform, download the sample CSV, fill it
                                      as prescribed, and upload. Asset name &
                                      location are mandatory; extra inputs
                                      improve accuracy of Climate VaR.
                                    </li>
                                    <li>
                                      For location accuracy, use satellite
                                      imagery from Google Maps or alternatives
                                      (Baidu, Gaode, OpenStreetMap) to avoid
                                      mismatches, especially in mainland China.
                                    </li>
                                    <li>
                                      Most inputs besides asset location can be
                                      updated later under the Asset Table
                                      section of the Dashboard.
                                    </li>
                                  </ul>
                                </Card.Body>
                              </Accordion.Collapse>
                            </Card>
                          </Accordion>
                        </div>
                      </Col>
                    </Row>
                  )}

                  {this.state.csvStep === 2 && (
                    <Form
                      style={{
                        paddingTop: "2%",
                        paddingLeft: "15%",
                        paddingRight: "15%",
                      }}
                    >
                      <Form.Field
                        id="form-input-control-portfolio"
                        control={Input}
                        value={this.state.portfolio}
                        onChange={(e) =>
                          this.setState({ portfolio: e.target.value })
                        }
                        style={{ border: "0px" }}
                        label="Portfolio Name"
                      />

                      <SelectVariables
                        onChange={this.onChange}
                        value={this.state.variables}
                      />

                      <div style={{ marginTop: 20 }}>
                        <Button
                          onClick={() => this.setState({ csvStep: 1 })}
                          style={{ marginRight: 8 }}
                        >
                          Back
                        </Button>
                        <Button
                          style={{ float: "right" }}
                          type="primary"
                          onClick={() => this.setState({ csvStep: 3 })}
                          disabled={!this.state.portfolio}
                        >
                          Next: Review & Submit
                        </Button>
                      </div>
                    </Form>
                  )}
                  {this.state.csvStep === 3 && (
                    <>
                      <div
                        style={{
                          marginBottom: 16,
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        {/* <p
                          style={{ color: "#666", fontSize: "14px", margin: 0 }}
                        >
                          <Icon name="table" />
                          Review your uploaded data. Click "Edit Table" to make
                          changes.
                        </p>

                        !this.state.isEditingTable ? (
                          <Button icon="edit" onClick={this.handleEnableEdit}>
                            Edit Table
                          </Button>
                        ) : (
                          <div>
                            <Button
                              onClick={this.handleCancelEdit}
                              style={{ marginRight: 8 }}
                            >
                              Cancel
                            </Button>
                            <Button
                              type="primary"
                              icon="save"
                              onClick={this.handleSaveChanges}
                            >
                              Save Changes
                            </Button>
                          </div>
                        )}*/}
                      </div>
                      {/* Show API Errors */}
                      {this.state.apiErrors && this.state.apiErrors.length > 0 && (
                        <div
                          style={{
                            background: "#fff2f0",
                            border: "1px solid #ffccc7",
                            padding: "12px",
                            borderRadius: "4px",
                            marginBottom: "16px",
                          }}
                        >
                          <p
                            style={{
                              color: "#ff4d4f",
                              marginBottom: 8,
                              fontWeight: 500,
                            }}
                          >
                            Please fix the following errors:
                          </p>
                          <ul style={{ paddingLeft: "20px", margin: 0 }}>
                            {this.state.apiErrors.map((err, index) => (
                              <li key={index} style={{ color: "#ff4d4f" }}>
                                {err}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}

                      <div
                        style={{
                          overflowX: "auto",
                          marginBottom: 20,
                        }}
                      >
                        <Table
                          className="custom-edit-table"
                          dataSource={
                            this.state.isEditingTable
                              ? this.state.editedCsvData
                              : this.state.csvData
                          }
                          columns={this.generateColumns()}
                          rowKey={(record, index) => index}
                          pagination={{ pageSize: 10 }}
                          scroll={{ x: true }}
                          bordered
                          style={{ minWidth: "100%" }}
                        />
                      </div>

                      <div style={{ marginTop: 20 }}>
                        <Button
                          onClick={() => this.setState({ csvStep: 2 })}
                          style={{ marginRight: 8 }}
                          disabled={this.state.isEditingTable}
                        >
                          Back
                        </Button>

                        <Button
                          type="primary"
                          onClick={this.onFileSubmit}
                          disabled={
                            !this.state.portfolio ||
                            !this.state.csv ||
                            !this.state.csvData ||
                            this.state.csvData.length === 0 ||
                            this.state.loading ||
                            this.state.isEditingTable
                          }
                          style={{ float: "right" }}
                        >
                          {this.state.loading ? (
                            <Spin size="small" />
                          ) : (
                            "Create Portfolio"
                          )}
                        </Button>
                      </div>

                      {this.state.isEditingTable && (
                        <p
                          style={{
                            color: "#ff4d4f",
                            fontSize: "12px",
                            marginTop: 8,
                          }}
                        >
                          <Icon name="warning sign" />
                          Please save or cancel your changes before proceeding.
                        </p>
                      )}
                    </>
                  )}
                </TabPane>
              </Tabs>
            </Col>
          </Row>
        </Container>

        <Modal open={this.state.infoOpen} onClose={this.handleClose} closeIcon>
          <Modal.Header style={{ backgroundColor: "white" }}>
            Confirmation
          </Modal.Header>
          <Modal.Content>
            <p>
              Do you want to upload CSV with these{" "}
              <Label>Optional Input </Label>?
            </p>
            <br />

            <Checkbox.Group
              style={{ paddingLeft: "1%" }}
              onChange={this.handleOptional}
            >
              <Checkbox value="Area"> Area</Checkbox>
              <br />
              <Checkbox value="Valuation"> Valuation</Checkbox>
              <br />
              <Checkbox value="Floors">Number of Floors</Checkbox>
              <Checkbox value="Solar">Solar Power Production (in gwh)</Checkbox>
              <Checkbox value="Wind">Wind Power Production (in gwh)</Checkbox>
              <Checkbox value="Hydro">Hydro Power Production (in gwh)</Checkbox>
              <Checkbox value="Construction Cost">
                Repairing / Construction Cost (in mil $)
              </Checkbox>

              <Checkbox value="Wheat">Wheat Production (in kg)</Checkbox>
              <Checkbox value="Rice">Rice Production (in kg)</Checkbox>
              <Checkbox value="Maize">Maize Production (in kg)</Checkbox>
              <Checkbox value="Fruit">Fruit Production (in kg)</Checkbox>
              <Checkbox value="Veg">Vegetable Production (in kg)</Checkbox>
              <Checkbox value="Ownership">OwnerShip</Checkbox>
            </Checkbox.Group>
            <br />
            <Button
              style={{
                float: "right",
                backgroundColor: "#18202F",
                color: "white",
              }}
              onClick={this.handleOpenDialog}
            >
              Submit
            </Button>
            <br />
            <br />
          </Modal.Content>
        </Modal>

        <Modal
          open={this.state.restrictOpen}
          onClose={this.handleClose}
          closeIcon
        >
          <Modal.Header style={{ backgroundColor: "white" }}>
            Error
          </Modal.Header>
          <Modal.Content>
            <p>
              You are only allowed to add{" "}
              {this.props.permissions.assets_allowed} assets for Analysis
            </p>
          </Modal.Content>
        </Modal>

        <Modal
          open={this.state.modalFileOpen}
          onClose={this.handleClose}
          closeIcon
        >
          <Modal.Header className="portfolio-header">
            Create Portfolio
          </Modal.Header>
          <Modal.Content
            style={{
              paddingLeft: "0.5rem",
              paddingTop: "0rem",
              paddingBottom: "0rem",
            }}
          >
            {Array.isArray(this.props.errors?.error) &&
            this.props.errors.error.length > 0 ? (
              <div>
                {this.props.errors.error.map((errorMessage, index) => (
                  <p key={index} style={{ color: "red" }}>
                    {errorMessage}
                  </p>
                ))}
              </div>
            ) : null}
            <Form>
              {this.props.location.state ? (
                <div>
                  <p style={{ marginLeft: "35%" }}>
                    New Portfolio{" "}
                    <Checkbox
                      label="OverWrite Existing"
                      value={this.state.overwrite}
                      onChange={(e) =>
                        this.setState(
                          { overwrite: !this.state.overwrite },
                          () => console.log("ovewrite", this.state.overwrite),
                        )
                      }
                      toggle
                    />
                  </p>
                  {this.state.overwrite ? (
                    <Form.Field
                      control={Input}
                      label="Portfolio Name"
                      value={this.state.portfolio}
                      onChange={(e) =>
                        this.setState({ portfolio: e.target.value })
                      }
                    />
                  ) : (
                    <Form.Field
                      control={Input}
                      label="Portfolio"
                      defaultValue={this.props.location.state.assets.name}
                      disabled
                    />
                  )}
                </div>
              ) : (
                <div>
                  <Form.Field
                    id="form-input-control-portfolio"
                    control={Input}
                    value={this.state.portfolio}
                    onChange={(e) =>
                      this.setState({ portfolio: e.target.value })
                    }
                    style={{ border: "0px" }}
                    label="Portfolio Name"
                  />

                  <SelectVariables
                    onChange={this.onChange}
                    value={this.state.variables}
                  />

                  {/* <Dropdown  placeholder="Variables for Analysis" fluid multiple  selection selectOnBlur={false} options={othersOptions} value={others} defaultValue={['Flood','Typhoon','Storm Surge']}onChange={(e,{value})=>this.handleChange(value,'others')}/> */}

                  <br />
                </div>
              )}

              {this.state.loading && this.props.errors.error === undefined ? (
                <div style={{ marginTop: "-40px", textAlign: "center" }}>
                  <Spin tip="Uploading..." size="large" />
                </div>
              ) : (
                <Button
                  disabled={
                    !this.state.portfolio || this.state.portfolio.length < 1
                  }
                  style={{
                    backgroundColor: "#18202F",
                    marginLeft: "45%",
                    color: "white",
                  }}
                  onClick={this.onFileSubmit}
                  primary
                >
                  Submit
                </Button>
              )}
            </Form>
          </Modal.Content>
        </Modal>

        <Modal
          open={this.state.modalCSVOpen}
          onClose={this.handleClose}
          closeIcon
        >
          <Modal.Header>Download Sample CSV</Modal.Header>
          <Modal.Content>
            Currency Dropdown
            <label>Select Currency</label>
            <br />
            <Select
              placeholder="Select a currency"
              value={this.state.csv_currency}
              onChange={this.handleCSVCurrencyChange}
              style={{ width: "50%", border: "1px solid grey" }}
            >
              <Select.Option value="USD">USD</Select.Option>
              {/*<Select.Option value="EUR">EUR</Select.Option>
              <Select.Option value="GBP">GBP</Select.Option>
                <Select.Option value="HKD">HKD</Select.Option>*/}
            </Select>
            <br />
            <br />
            {/* Unit Dropdown 
            <label>Select Unit</label>
            <br />

            <Select
              placeholder="Select a unit"
              value={this.state.csv_unit}
              onChange={this.handleCSVUnitChange}
              style={{ width: "50%", border: "1px solid grey" }}
            >
              <Select.Option value="meter">Meter</Select.Option>
              <Select.Option value="inch">Inch</Select.Option>
            </Select>

            <br />
                <br />*/}
            <Button
              style={{
                backgroundColor: "#18202F",
                float: "right",
                color: "white",
              }}
              loading={this.state.loading}
              onClick={this.handleCSVSubmit}
              primary
            >
              Submit
            </Button>
            <br />
            <br />
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    errors: state.locus.errors,
    locus: state.locus,
    company: state.company.company,
    permissions: state.locus.permissions,
    name: state.locus.name,
    point: state.locus.point,
    indices: state.locus.indices,
    transition: state.locus.transition,
    company_name: state.locus.company_name,
    company_location: state.locus.company_location,
    auth: state.auth,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addLocations: (formdata) => {
      return dispatch(locus.addLocations(formdata));
    },
    addCompanyLocations: (formdata) => {
      return dispatch(locus.addCompanyLocations(formdata));
    },
    Notification: (formdata) => {
      return dispatch(locus.Notification(formdata));
    },
    addBuildingLocations: (formdata) => {
      return dispatch(locus.addBuildingLocations(formdata));
    },
    getCompany: () => {
      return dispatch(company.getCompanies());
    },
    logout: () => {
      return dispatch(auth.logout());
    },
    changeTitle: (title) => {
      return dispatch(changeTitle(title));
    },
    getName: (formdata) => {
      return dispatch(locus.getName(formdata));
    },
    getCoordinates: (formdata) => {
      return dispatch(locus.getCoordinates(formdata));
    },
    getIndices: (formdata) => {
      return dispatch(locus.getIndices(formdata));
    },
    addIndex: (formdata) => {
      return dispatch(locus.addIndex(formdata));
    },
    getTransition: (formdata) => {
      return dispatch(locus.getTransition(formdata));
    },
    getCompanyName: (formdata) => {
      return dispatch(locus.getCompanyName(formdata));
    },
    getCompanyLocations: (formdata) => {
      return dispatch(locus.getCompanyLocations(formdata));
    },
    clearErrors: () => {
      dispatch({ type: "CLEAR_ERRORS" });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Location);
